export type HiiveMemberProfileRow = {
  userId: string;
  fullName: string | null;
  username: string | null;
  profileImage: string | null;
  isBlocked?: boolean;
  isBuddy?: boolean;
  mutualCount?: number;
  isYou?: boolean;
};

export type HiiveMemberListItem = {
  id: string;
  name: string;
  username: string;
  image: string | null;
  isBlocked: boolean;
  isBuddy: boolean;
  mutualCount: number;
  isYou: boolean;
};

export function mapHiiveMemberProfiles(
  members: HiiveMemberProfileRow[],
): HiiveMemberListItem[] {
  return members.map((member) => ({
    id: member.userId,
    name: member.fullName ?? "Anonymous",
    username: member.username ?? "",
    image: member.profileImage,
    isBlocked: Boolean(member.isBlocked),
    isBuddy: Boolean(member.isBuddy),
    mutualCount:
      typeof member.mutualCount === "number" ? member.mutualCount : 0,
    isYou: Boolean(member.isYou),
  }));
}
